module.exports = __webpack_public_path__ + "static/media/sponsor5.cf27e404.jpg";